<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-overlay :show="isLoading" rounded="sm">
            <div class="row">
                <div class="col-12" v-show="expedienteNuevo">
                    <form class="needs-validation" @submit.prevent="formSubmit">
                        <div class="card">
                            <div class="card-body">
                                <h2>1. Datos personales</h2>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-12">
                                        <label >Tramite a realizar</label>
                                        <v-select :options="expedientes_tipos"
                                                  label="descripcion"
                                                  v-model="model.expediente_tipo_id"
                                                  :reduce="descripcion=>descripcion.id"
                                                  :class="{ 'is-invalid': submitted && $v.model.expediente_tipo_id.$error }"
                                        />
                                        <div v-if="submitted && $v.model.expediente_tipo_id.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.expediente_tipo_id.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-6">
                                        <label>Oficina Origen</label>
                                        <v-select
                                                :options="user.oficinas"
                                                v-model="model.oficina_origen_id"
                                                aria-placeholder="Seleccione"
                                                label="descripcion"
                                                :reduce="oficina=>oficina.id"
                                                :class="{ 'is-invalid': submitted && $v.model.oficina_origen_id.$error }"
                                        >
                                        </v-select>
                                        <div v-if="submitted && $v.model.oficina_origen_id.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.oficina_origen_id.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label>Oficina destino</label>
                                        <v-select
                                                multiple
                                                :options="oficinas"
                                                v-model="model.oficinas_destino"
                                                aria-placeholder="Seleccione"
                                                label="descripcion"
                                                :class="{ 'is-invalid': submitted && $v.model.oficinas_destino.$error }"
                                        >
                                        </v-select>
                                        <div v-if="submitted && $v.model.oficinas_destino.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.oficinas_destino.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-6">
                                        <label >Tipo de documento del solicitante</label>
                                        <select class="form-control" v-model="model.documento_identidad_tipo"
                                                :class="{ 'is-invalid': submitted && $v.model.documento_identidad_tipo.$error }"
                                                disabled
                                        >
                                            <option value="01">DNI</option>
                                            <option value="06">RUC</option>
                                        </select>
                                        <div v-if="submitted && $v.model.documento_identidad_tipo.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.documento_identidad_tipo.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label >Número de documento del solicitante</label>
                                        <input class="form-control"
                                               v-model="model.documento_identidad_numero"
                                               :class="{ 'is-invalid': submitted && $v.model.documento_identidad_numero.$error }"
                                               disabled
                                        />
                                        <div v-if="submitted && $v.model.documento_identidad_numero.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.documento_identidad_numero.required">Este valor es requerido.</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-6">
                                        <label>Apellidos Nombres / Denominación:</label>
                                        <input class="form-control" v-model="model.denominacion"
                                               :class="{ 'is-invalid': submitted && $v.model.denominacion.$error }"
                                               disabled
                                        />
                                        <div v-if="submitted && $v.model.denominacion.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.denominacion.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label>Escuela profesional del solicitante</label>
                                        <v-select
                                                :options="carreras_profesionales"
                                                label="carrera"
                                                :reduce="carrera=>carrera.codigo"
                                                v-model="model.codigo_carrera"
                                        />
                                    </div>
                                </div>

                                <div class="form-row big-font">
                                    <div class="form-group col-md-4">
                                        <label>Celular/Telefono</label>
                                        <input class="form-control" v-model="model.celular"
                                               :class="{ 'is-invalid': submitted && $v.model.celular.$error }"
                                        />
                                        <div v-if="submitted && $v.model.celular.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.celular.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label>Correo eletronico</label>
                                        <input class="form-control" v-model="model.correo"
                                               :class="{ 'is-invalid': submitted && $v.model.correo.$error }"
                                        />
                                        <div v-if="submitted && $v.model.correo.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.correo.required">Este valor es requerido.</span>
                                        </div>
                                        <div v-if="submitted && $v.model.correo.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.correo.email">Formato incorrecto, el correo debe ser ejemplo@dominio.com</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- end row -->
                            </div>

                        </div>


                        <div class="card">
                            <div class="card-body pt-2">
                                <h2>2. Datos del documento</h2>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-12">
                                        <label>Fundamentación de la solicitud </label>

                                        <textarea v-model="model.fundamentacion"
                                                  class="form-control"
                                                  :maxlength="500"
                                                  rows="3"
                                                  placeholder="Esta area esta limitada a 500 caracteres."
                                                  :class="{ 'is-invalid': submitted && $v.model.fundamentacion.$error }"
                                        />
                                        <div v-if="submitted && $v.model.fundamentacion.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.fundamentacion.required">Este campo es requerido.</span>
                                        </div>
                                        <div class="text-center">
                                            <p  v-if="model.fundamentacion"
                                                class="badge position-absolute"
                                                :class="{ 'badge-success': model.fundamentacion.length !== 500,
                                'badge-danger': model.fundamentacion.length === 500 }"
                                            >
                                                {{ model.fundamentacion.length }} /
                                                500
                                            </p>
                                        </div>

                                    </div>

                                </div>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-12">
                                        <label>Documentos que se adjuntan</label>
                                        <textarea
                                                v-model="model.documentos_adjuntos"
                                                class="form-control"
                                                :maxlength="500"
                                                rows="3"
                                                placeholder="Esta area esta limitada a 500 caracteres."
                                                :class="{ 'is-invalid': submitted && $v.model.documentos_adjuntos.$error }"
                                        />
                                        <div v-if="submitted && $v.model.documentos_adjuntos.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.documentos_adjuntos.required">Este campo es requerido.</span>
                                        </div>
                                        <div class="text-center">
                                            <p  v-if="model.documentos_adjuntos"
                                                class="badge position-absolute"
                                                :class="{ 'badge-success': model.documentos_adjuntos.length !== 500,
                                'badge-danger': model.documentos_adjuntos.length === 500 }"
                                            >
                                                {{ model.documentos_adjuntos.length }} /
                                                500
                                            </p>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-10">
                                        <label>Documentos adjuntos digital</label>
                                        <div class="input-group">
                                            <b-form-file
                                                    id="file-with-icon-end"
                                                    placeholder="Buscar Archivo"
                                                    v-model="archivoActual"

                                                    @input="agregarAchivo"
                                                    multiple
                                            />

                                            <div class="input-group-append">
                                              <span class="input-group-text bg-transparent" >
                                                <i class="bx bxs-folder-open" />
                                              </span>
                                            </div>
                                        </div>
                                        <small  class="form-text font-size-11 " v-show="files!=null ">
                                            <table class="table table-sm">
                                                <thead>
                                                <th>Archivo</th>
                                                <th>Tamaño</th>
                                                <th>Op</th>
                                                </thead>
                                                <tbody>
                                                <tr  v-for="(data2,index2) in files"  v-bind:key="index2">
                                                    <td>
                                                        {{data2.name}}
                                                    </td>
                                                    <td>
                                                        {{(data2.size / (1024*1024)).toFixed(2)}} Mb
                                                    </td>
                                                    <td>
                                                        <a  class="btn btn-sm btn-outline-danger" v-on:click="borrar(index2)">
                                                            <i class="fa fa-trash "></i>
                                                        </a>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>
                                            <!--<ul>
                                              <li v-for="(data,index) in data.archivos_derivacion"  v-bind:key="index">
                                                {{data.name}}
                                              </li>
                                            </ul>-->
                                        </small>

                                    </div>
                                    <!--<div class="form-group col-md-2">
                                        <label>Folios</label>
                                        <input class="form-control" v-model="model.folios">
                                    </div>-->

                                </div>
                                <!-- end row -->
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <b-button block variant="primary" size="lg" type="submit" :disabled="isLoading">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isLoading"/>
                                            Guardar y enviar
                                        </b-button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- end card -->
                    </form>
                </div>
                <!-- end col -->
            </div>
            <div class="row"  v-show="!expedienteNuevo"  v-for="(model,index) in models" v-bind:key="index">
                <div class="col-md-12">
                    <section class="section">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12">
                                    <b-card header-class="bg-transparent border-success" class="border border-success">
                                        <template v-slot:header>
                                            <h5 class="my-0 text-success">
                                                <i class="mdi mdi-alert-circle-outline mr-3"></i>Se registro el expediente
                                            </h5>
                                        </template>

                                        <h4>Numero de expediente: <strong> {{model.numero_referencia}}</strong></h4>
                                        <p>
                                        </p>
                                        <p>
                                            Numero documento:<strong>{{model.documento_identidad_numero}}</strong>
                                        </p>
                                        <p>
                                            Nombres:<strong>{{model.denominacion}}</strong>
                                        </p>
                                        <p>
                                            Correo:<strong>{{model.correo}}</strong>
                                        </p>
                                        <p>
                                        </p>
                                    </b-card>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>


        </b-overlay>
    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import constantes from "../../../config/Constantes";
    import {email, required} from "vuelidate/lib/validators";

    //  import DatePicker from "vue2-datepicker";

    /**
     * Form Layouts component
     */
    export default {
        page: {
            title: "Registro de socios",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, PageHeader },
        validations: {
            model: {
                documento_identidad_numero: {required},
                expediente_tipo_id: {required},
                documento_identidad_tipo:{required},
                denominacion:{required},
                celular:{required},
                correo:{required, email},
                fundamentacion:{required},
                documentos_adjuntos:{required},
                oficinas_destino:{required},
                oficina_origen_id:{required}
            }
        },


        data() {
            return {
                user:{},
                title: "Registro de nuevo expediente",
                items: [
                    {
                        text: "Administracion",
                        href: "/"
                    },
                    {
                        text: "Edicion ubicaciones",
                        active: true
                    }
                ],
                name:'',
                siglas:'',
                model:{
                    correo:'',
                    denominacion:'',
                    celular:'',
                    documento_identidad_numero:'',
                    documento_identidad_tipo:'01',
                    oficinas_destino:null
                },
                isLoading:false,
                carreras_profesionales:constantes.carreras_profesionales,
                submitted: false,
                usuarios:[],
                expedientes_tipos:[],
                oficinas:[],
                files:null,
                expedienteNuevo:true,
                models:null,
                archivoActual:null

            };
        },
        methods:
        {
            borrar(index){
                this.removeField(this.files,index);

            },
            removeField(v_array,index) {
                this.$delete(v_array,index);

                //v_array.splice(index, 1);
            },
            agregarAchivo(){
                if(this.files===null){
                    this.files=[];
                }
                this.archivoActual.forEach((item)=>{
                    this.files.push(item);
                })


            },

            // eslint-disable-next-line no-unused-vars
            formSubmit(e) {
                this.submitted = true;
                // stop here if form is invalid
                this.$v.$touch();
                if(this.$v.$error==false){
                    this.guardar();
                }

            },
            guardar(){
                this.isLoading=true;
                this.model_save = Object.assign({}, this.model);
                this.model_save.oficinas_destino=JSON.stringify(this.model_save.oficinas_destino);
                let formData = new FormData();
                Object.keys(this.model_save).forEach(key => {
                    const data = this.model_save[key];
                    formData.append(key,data);
                })
                this.files.forEach((item)=>{
                    formData.append('files[]',item);
                });

                this.axios.post( process.env.VUE_APP_BACKEND+'/api/expedientes/interno' ,
                    formData
                )
                    .then( (response) =>{
                        if(response.data.success)
                        {
                            this.expedienteNuevo=false;
                            this.models=response.data.models;
                        }

                    })
                    .finally(()=>
                    {
                        this.isLoading=false;
                        this.isLoadingName=false;
                    })
                    .catch(() =>{
                        this.isLoading=false;
                        //console.log(error);
                    });
            },
        }
        ,
        created() {

        },
        mounted() {
            this.isLoading=true;
            this.axios.get(process.env.VUE_APP_BACKEND+'/api/usuarios/actual')
                .then((response)=>{
                    this.model.denominacion=response.data.nombres;
                    this.model.celular=response.data.celular;
                    this.model.correo=response.data.email;
                    this.model.documento_identidad_numero=response.data.dni;
                })
            .finally(()=>this.isLoading=false);

            this.axios.get(process.env.VUE_APP_BACKEND+'/api/expedientes/tipos/interno')
                .then((response)=>
                {
                    this.expedientes_tipos=response.data;
                })
                .finally(()=>{

                })
                .catch(()=>{

                });
            this.axios.get(process.env.VUE_APP_BACKEND+'/api/oficinas')
                .then((response)=>
                {
                    this.oficinas=response.data;
                })
                .finally(()=>{

                })
                .catch(()=>{

                });
            this.user=JSON.parse(localStorage.getItem('user'));

        }
    };
</script>
